import { render, staticRenderFns } from "./admin-companies.vue?vue&type=template&id=e9622530&scoped=true&"
import script from "./admin-companies.ts?vue&type=script&lang=ts&"
export * from "./admin-companies.ts?vue&type=script&lang=ts&"
import style0 from "./admin-companies.vue?vue&type=style&index=0&id=e9622530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9622530",
  null
  
)

export default component.exports